import { Container, Divider } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  DateRangePicker,
  ModalError,
  ModalSuccess,
  ModalTable,
  ModalWarning,
  Page,
  PrimaryButton,
  SelectInput,
  StatusChip,
  SwitchInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment-timezone";
import { Fragment, useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDate, formatPayloadDate, getErrors } from "utils";

const GenerateCCID = () => {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = "Generate CCID";

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    start_date: null,
    end_date: null,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionDsp, setOptionDsp] = useState([]);
  const [payload, setPayload] = useState({
    dsp_id: 0,
    is_backclaim: false,
    periods: [],
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [dataTableModal, setDataTableModal] = useState([]);
  const [queryParamsModal, setQueryParamsModal] = useState({
    page: 1,
    size: 10,
    search: "",
    start_date: null,
    end_date: null,
  });
  const [tableTotalPageModal, setTableTotalPageModal] = useState(1);

  console.log({ ccid: payload?.periods });
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeQueryParamsModal = (value, key) => {
    setQueryParamsModal(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const checkedAction = item => {
    const startDate = formatPayloadDate(item?.start_date);
    const endDate = formatPayloadDate(item?.end_date);

    return payload?.periods?.some(
      period =>
        formatPayloadDate(period?.start) === startDate &&
        formatPayloadDate(period?.end) === endDate
    );
  };
  const handleCheckboxAction = (event, option) => {
    const { checked } = event?.target || {};

    const startDate = formatPayloadDate(option?.start_date);
    const endDate = formatPayloadDate(option?.end_date);

    setPayload(currentState => {
      const periods = currentState?.periods || [];

      if (checked) {
        const alreadySelected = periods.some(
          period =>
            formatPayloadDate(period?.start) === startDate &&
            formatPayloadDate(period?.end) === endDate
        );

        if (alreadySelected) {
          return currentState;
        }

        return {
          ...currentState,
          periods: [
            ...periods,
            {
              start: startDate,
              end: endDate,
            },
          ],
        };
      }

      return {
        ...currentState,
        periods: periods.filter(
          period =>
            formatPayloadDate(period?.start) !== startDate ||
            formatPayloadDate(period?.end) !== endDate
        ),
      };
    });
  };
  const handleGenerateCCID = () => {
    ModalWarning(
      "Are you sure want to generate this data?",
      "Generate CCID"
    ).then(res => res.isConfirmed && postGenerateCCID());
  };
  const handleChangeDSP = e => {
    setPayload(currentState => ({
      ...currentState,
      dsp_id: e?.target?.value,
      periods: [],
    }));
  };
  const getOptionDsp = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/ccid/filter-dsp`, {
        headers,
      });
      setOptionDsp(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    const { start_date, end_date, ...rest } = queryParams;
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/ccid/datatable`, {
        headers,
        params: {
          ...rest,
          dsp_id: payload?.dsp_id,
          start_date: formatPayloadDate(start_date),
          end_date: formatPayloadDate(end_date),
        },
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getDataTableModal = async () => {
    const { start_date, end_date, ...rest } = queryParamsModal;
    try {
      setLoadingModal(true);
      const res = await axios.get(`${hardBaseUrl}/ccid/detail`, {
        headers,
        params: {
          ...rest,
          dsp_id: payload?.dsp_id,
          start_date: formatPayloadDate(start_date),
          end_date: formatPayloadDate(end_date),
        },
      });
      const { data, meta } = res?.data;
      setDataTableModal(data || []);
      const pageCount = getTotalPage(meta?.total, queryParamsModal?.size);
      setTableTotalPageModal(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingModal(false);
    }
  };
  const debounceDataTableModal = useCallback(
    debounce(() => {
      getDataTableModal();
    }, 500),
    [queryParamsModal]
  );

  const postGenerateCCID = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.post(`${hardBaseUrl}/ccid/generate`, payload, {
        headers,
      });
      ModalSuccess(
        res?.data?.message || "Successfully generate CCID"
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getOptionDsp();
  }, []);
  useEffect(() => {
    if (payload?.dsp_id) {
      getDataTable();
    }
  }, [queryParams, payload?.dsp_id]);
  useEffect(() => {
    if (modalVisible) {
      const isSearching = Boolean(queryParamsModal?.search);
      if (isSearching) {
        debounceDataTableModal();
        return () => {
          debounceDataTableModal.cancel();
        };
      } else {
        getDataTableModal();
      }
    }
  }, [queryParamsModal, debounceDataTableModal, modalVisible]);

  return (
    <Page className={classes.root} title={pageTitle}>
      <Container maxWidth={false}>
        <HeaderTitle
          title="CCID"
          breadcrumbData={breadcrumbData({ pageTitle })}
        />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid container justifyContent="space-between" my={2}>
          <Grid item>
            <Grid container columnSpacing={2} alignItems="center">
              <Grid item>
                <SelectInput
                  label="DSP"
                  options={optionDsp}
                  optionKey="dsp_id"
                  optionLabel="dsp_name"
                  value={payload?.dsp_id || ""}
                  onChange={handleChangeDSP}
                  placeholder="Select DSP"
                  width={200}
                />
              </Grid>
              {!!payload?.dsp_id && (
                <Fragment>
                  <Grid item>
                    <DateRangePicker
                      label="Data Period"
                      startDate={queryParams?.start_date}
                      endDate={queryParams?.end_date}
                      handleChangeStartDate={value =>
                        handleChangeQueryParams(value, "start_date")
                      }
                      handleChangeEndDate={value =>
                        handleChangeQueryParams(value, "end_date")
                      }
                      width="315px"
                      startMinDate={moment("2010-01", "YYYY-MM")}
                      endMaxDate={moment().add(10, "years")}
                      clear
                    />
                  </Grid>
                  <Grid item>
                    <SwitchInput
                      checked={payload?.is_backclaim}
                      label="Generate CCID Backclaim"
                      onChange={e =>
                        handleChangePayload(e?.target?.checked, "is_backclaim")
                      }
                    />
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </Grid>
          {!!payload?.dsp_id && (
            <Grid item>
              <PrimaryButton
                label="Generate CCID"
                onClick={handleGenerateCCID}
                disabled={!payload?.periods?.length}
              />
            </Grid>
          )}
        </Grid>
        {payload?.dsp_id ? (
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveAction
            handleView={item => {
              setModalVisible(true);
              setQueryParamsModal(currentState => ({
                ...currentState,
                start_date: formatPayloadDate(item?.start_date),
                end_date: formatPayloadDate(item?.end_date),
              }));
            }}
            disabledCheckboxAction={item =>
              item?.status === "In Progress" ||
              (item?.status === "Finish" && !payload?.is_backclaim)
            }
            checkedAction={checkedAction}
            handleCheckboxAction={handleCheckboxAction}
          />
        ) : (
          <Typography
            fontSize={18}
            fontWeight={400}
            color="#687083"
            align="center"
          >
            Select DSP first to process the data
          </Typography>
        )}
        {modalVisible && (
          <ModalTable
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            search
            searchValue={queryParamsModal?.search}
            handleSearch={e =>
              handleChangeQueryParamsModal(e?.target?.value, "search")
            }
            title="List Publisher"
            isLoading={loadingModal}
            dataTable={dataTableModal}
            columnTable={columnTableModal}
            page={queryParamsModal?.page}
            pageSize={queryParamsModal?.size}
            pageCount={tableTotalPageModal}
            handleChangePage={(_, page) =>
              handleChangeQueryParamsModal(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParamsModal(e?.target?.value, "size")
            }
          />
        )}
      </Container>
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "CCID",
    link: "/admin/generate-ccid",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const columnTable = [
  {
    name: "dsp_name",
    title: "DSP",
  },
  {
    name: "all",
    title: "Data Period",
    renderText: date =>
      `${formatDate(date?.start_date)} - ${formatDate(date?.end_date)}`,
  },
  {
    name: "generation_count",
    title: "Generate Count",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={status}
        type={
          status === "In Progress"
            ? "active"
            : status === "Open"
            ? "danger"
            : status === "Finish"
            ? "success"
            : "default"
        }
      />
    ),
  },
];
const columnTableModal = [
  {
    name: "publisher_name",
    title: "Publisher Name",
  },
  {
    name: "sub_reporting",
    title: "Sub Reporting",
    renderText: item => <ArrayChip list={item} />,
  },
];

export default GenerateCCID;
